var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("工程师名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", [_vm._v(_vm._s(_vm.engineer.name))])
      ])
    ]),
    _vm._v(" "),
    _vm.engineer.serveNo != null
      ? _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("服务工号")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.engineer.serveNo))])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.engineer.contactTel != null
      ? _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("联系电话")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.engineer.contactTel))])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("负责数量")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.engineerShopList == null ? 0 : _vm.engineerShopList.length
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-caption bg-white dashed" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "swb-btn swb-btn-mini fr",
          on: { click: _vm.setEngineerShop }
        },
        [_vm._v("新增")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              ref: "ssuList",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.engineerShopList, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "comName", label: "网点名称", align: "left" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "left",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.deleteItem(rows.row.id)
                              }
                            }
                          },
                          [_vm._v("移除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption bg-white dashed" }, [
      _c("div", { staticClass: "fl" }, [_c("span", [_vm._v("工程师信息")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fl" }, [
      _c("span", [_vm._v("负责网点信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-540a62b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-540a62b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/ServicerXngineerShopList.vue
// module id = 1941
// module chunks = 1